<template>
    <div class="d-none d-sm-flex">
            
        <router-link class="router-link-active" :title="item.tooltip"
            v-for="item in items" :key="item.link" icon :to="{ name: item.routerName } || null"
            @click="item.action || null">
                    <v-icon size="20px">
                        {{ item.icon }}
                        </v-icon>
        </router-link>
        
        <a class="nav-link" @click="updateSchoolModal = !updateSchoolModal" title="Update School">
            <v-icon size="20px">mdi-cog</v-icon>
        </a> &nbsp;
        <sign-out :view="'top'"/>
        <update-school-info v-if="updateSchoolModal"/>
    </div>
</template>

<script>
import SignOut from '../SignOut.vue';
import UpdateSchoolInfo from '../UpdateSchoolInfo.vue'
  export default {
  components: { UpdateSchoolInfo, SignOut},
    name: 'TopCard',
    data: () => ({
        updateSchoolModal: false,
        showMenu: true,
        items: [
            { tooltip: 'Home', icon: 'mdi-view-dashboard', routerName: 'ModuleSelector' },
        ],
    }),
  }
</script>

<style scoped>
.nav-link{
    text-decoration: none;
    color: #44546E !important;
    opacity: 0.85;
    transition: opacity 0.2s ease, color 0.2s ease;
}
.nav-link:hover{
    opacity: 1;
    color: #FB8C00 !important;
}
.router-link-active{
    color: #FB8C00 !important;
    padding-right: 10px;
    font-weight: 700;
}
</style>
